var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-actions"},[_c('a',{staticClass:"btn btn-sm btn-outline-warning",attrs:{"href":`http://gitlab.meta.com.br/${_vm.rowData.path}`,"target":"_blank","title":"Abrir no GitLab"}},[_c('img',{staticStyle:{"width":"20px"},attrs:{"src":"/img/gitlab-icon.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }